import persons from '@/mixins/persons';
import enums from '@/mixins/enums';

export default {
  mixins: [persons, enums],
  methods: {
    /*
    * Methods returns stringified model
    * */
    stringifyModel(model) {
      const { DistributionChannelEnum } = this.enums;
      const { hash } = this.$route.query;
      const { broker } = this.model;
      const hasBroker = broker.email || broker.phone || broker.name || broker.surname || broker.number;
      return JSON.parse(JSON.stringify(model, (key, value) => {
        // If broker send his link to client
        if ((hasBroker || hash) && key === 'distributionChannel') return DistributionChannelEnum.VIP.name$ || 'VIP';
        // If value is nationality/country return object
        if (value && !!value.area) {
          return {
            value: value.value,
            label: value.label,
            search: value.search,
            optgroup: value.optgroup,
            area: value.area,
            skLabel: value.skLabel,
          };
        }
        // If value is enumeration return only value
        if (value && !!value.name$) return value.name$;
        return value;
      }));
    },
    async saveForm() {
      try {
        const { DeliveryTypeEnum, LoaderEnum } = this.enums;

        // If broker sent link to client set "brokerSentApplicationToClient" on model for validations
        const { hash, channel } = this.$route.query;
        if (hash && !channel) this.model.broker.brokerSentApplicationToClient = true;

        const requiredAttachments = [];

        this.personsWithRequiredAttachments.forEach((person) => {
          person.requiredAttachments.forEach((requiredAttachment) => {
            const tempRequiredAttachment = JSON.parse(JSON.stringify((requiredAttachment)));
            tempRequiredAttachment.personIndex = person.personIndex;
            requiredAttachments.push(tempRequiredAttachment);
          });
        });

        this.personsWithRequiredAttachmentsForCourier.forEach((person) => {
          person.requiredAttachments.forEach((requiredAttachment) => {
            const tempRequiredAttachment = JSON.parse(JSON.stringify((requiredAttachment)));
            tempRequiredAttachment.personIndex = person.personIndex;
            requiredAttachments.push(tempRequiredAttachment);
          });
        });

        const attachmentsToDelete = [];

        this.model.attachments.array_hd7ov6$_0.forEach((attachment, index) => {
          const { personIndex, type } = attachment;
          let isInRequired = false;
          requiredAttachments.forEach((requiredAttachment) => {
            if (requiredAttachment.personIndex === personIndex && requiredAttachment.name$ === type) {
              isInRequired = true;
            }
          });
          if (!isInRequired) {
            attachment.index = index;
            attachmentsToDelete.push(attachment);
          }
        });

        attachmentsToDelete.forEach((attachment) => {
          const { uuid, index } = attachment;
          this.$axios.get(`/uzp_api/japi/IUzpApi/deleteAttachment?uuid=${uuid}`);
          this.model.attachments.array_hd7ov6$_0 = this.model.attachments.array_hd7ov6$_0.filter((att) => att.uuid !== uuid);
          this.$store.commit('REMOVE_ATTACHMENT', index);
        });

        if (this.model.delivery.deliveryType === this.enums.DeliveryTypeEnum.CONTACT_PLACE) {
          this.model.delivery.email = this.model.insurer.email;
        }

        const pureModel = this.stringifyModel(this.model);
        const family = this.insuredPersons.length > 1;
        this.model.loader = family ? LoaderEnum.FAMILY_SAVING : LoaderEnum.SAVING;

        const saveRes = await this.$axios.post(
          `/uzp_api/japi/IUzpApi/${family ? 'familySave' : 'save'}`,
          [pureModel],
        );

        this.model.saveResponse = saveRes.data;

        const dataForRatingWidget = {
          saveResponse: saveRes.data,
          insurer: {
            phone: this.model.insurer.phone,
            email: this.model.insurer.email,
          },
        };

        if (this.model.delivery.deliveryType === DeliveryTypeEnum.E_SIGNATURE) {
          window.localStorage.setItem('data_for_rating_widget', JSON.stringify(dataForRatingWidget));
          return 'ESignature';
        }
        return 'ThankYouSuccess';
      } catch (e) {
        this.$store.state.saveError = e;
        return 'ThankYouFail';
      } finally {
        this.model.loader = null;
      }
    },
  },
};
